// import React, { useState } from 'react';
// import { TextField, Button, IconButton, Select, MenuItem } from '@mui/material';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import SearchIcon from '@mui/icons-material/Search';

// import ProductSettings from '../Components/Settings/ProductSettings';
// import OperatorSettings from '../Components/Settings/OperatorSettings';
// import BEPSettings from '../Components/Settings/BEPSettings';

const SettingsPage = () => {
  // State for holding the selected setting type and search query
  // const [settingType, setSettingType] = useState(null);
  // const [search, setSearch] = useState('');

  // // Settings type list similar to what you had in Vue
  // const settingsTypeList = [
  //   { text: 'Product Settings', value: 'product-settings' },
  //   { text: 'Operator Settings', value: 'operator-settings' },
  //   { text: 'BEP Settings', value: 'bep-settings' },
  // ];

  // // Handle component search action
  // const searchSelected = () => {
  //   if (settingType === 'product-settings') {
  //     // Assuming ProductSettings has a search function
  //     document.getElementById('product-settings').search();
  //   } else if (settingType === 'operator-settings') {
  //     document.getElementById('operator-settings').search();
  //   } else if (settingType === 'bep-settings') {
  //     document.getElementById('bep-settings').search();
  //   }
  // };

  // // Handle export action for the selected component
  // const exportSelected = () => {
  //   if (settingType === 'product-settings') {
  //     document.getElementById('product-settings').exportCsv();
  //   } else if (settingType === 'operator-settings') {
  //     document.getElementById('operator-settings').exportCsv();
  //   } else if (settingType === 'bep-settings') {
  //     document.getElementById('bep-settings').exportCsv();
  //   }
  // };

  // // Render the correct settings component based on the selected settingType
  // const renderSettingComponent = () => {
  //   if (settingType === 'product-settings') {
  //     return <ProductSettings id="product-settings" search={search} />;
  //   } else if (settingType === 'operator-settings') {
  //     return <OperatorSettings id="operator-settings" search={search} />;
  //   } else if (settingType === 'bep-settings') {
  //     return <BEPSettings id="bep-settings" search={search} />;
  //   }
  //   return null;
  // };

  return (
    <div>Reserved for v2</div>
  );
  //   <div>
  //     {/* Settings Type Dropdown */}
  //     <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
  //       <Select
  //         label="Settings Type"
  //         value={settingType}
  //         onChange={(e) => setSettingType(e.target.value)}
  //         style={{ width: '300px' }}
  //       >
  //         {settingsTypeList.map((setting) => (
  //           <MenuItem key={setting.value} value={setting.value}>
  //             {setting.text}
  //           </MenuItem>
  //         ))}
  //       </Select>

  //       {/* Search TextField */}
  //       <TextField
  //         label="Setting Name"
  //         value={search}
  //         onChange={(e) => setSearch(e.target.value)}
  //         onKeyPress={(e) => e.key === 'Enter' && searchSelected()}
  //         InputProps={{
  //           endAdornment: (
  //             <IconButton onClick={searchSelected}>
  //               <SearchIcon />
  //             </IconButton>
  //           ),
  //         }}
  //         style={{ flex: 1 }}
  //       />

  //       {/* Buttons for Search and Export */}
  //       <IconButton color="primary" onClick={exportSelected}>
  //         <CloudDownloadIcon />
  //       </IconButton>
  //       <IconButton color="primary" onClick={searchSelected}>
  //         <SearchIcon />
  //       </IconButton>
  //     </div>

  //     {/* Render the correct component based on the selected settingType */}
  //     {renderSettingComponent()}
  //   </div>
  // );
};

export default SettingsPage;
